import { Component, Inject } from '@angular/core';

import { BehaviorSubject, Subject, combineLatest, forkJoin, of } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserService } from '../../humain/user/services/user.service';

import { PerimetreAntenne } from '../entities/perimetre-antenne.entity';
import { PerimetresService } from '../services/perimetres.service';

export interface PerimetreUtilisateurDialogData {
}

@Component({
	templateUrl: 'perimetre-utilisateur-dialog.html',
	styleUrls: ['perimetre-utilisateur-dialog.css'],
})
export class PerimetreUtilisateurDialogComponent {
	antenneResetCommands$ = new Subject<number | null | undefined>();
	antenneId$ = new BehaviorSubject<number | null>(null);
	displayAntenneSelector: boolean = false;
	loading = true;
	perimetreAntennesCAC!: PerimetreAntenne[];
	perimetreAntennesCC!: PerimetreAntenne[];

	constructor(
		_dialogRef: MatDialogRef<PerimetreUtilisateurDialogComponent>,
		@Inject(MAT_DIALOG_DATA) _data: PerimetreUtilisateurDialogData,
		@Inject(PerimetresService) perimetresService: PerimetresService,
		@Inject(UserService) userService: UserService,
	) {
		let user$ = userService.getCurrentUserTLR();

		user$.subscribe(
			user => {
				let isCce = user.role === 'CCE';
				this.displayAntenneSelector = isCce;
			} 
		);
		
		let loadedData$ = combineLatest([user$, this.antenneId$]).pipe(
			tap(
				(_) => {
					this.perimetreAntennesCAC = [];
					this.perimetreAntennesCC = [];
				}
			),
			filter(
				([user, antenneId]) => user.role !== 'CCE' || antenneId != null
			),
			tap(
				(_) => this.loading = true
			),
			mergeMap(
				([_user, antenneId]) => {
					let perimetresCAC$ = perimetresService.listPerimetresForUser('current', 'CAC', antenneId);
					let perimetresCC$ = perimetresService.listPerimetresForUser('current', 'CC', antenneId);
					
					return forkJoin({
						cac: perimetresCAC$,
						cc: perimetresCC$,
					});
				}
			),
			tap(
				(_) => this.loading = false
			),
		);
		
		loadedData$.subscribe(
			({cac, cc}) => {
				// Binder les donnees sur la vue
				this.perimetreAntennesCAC = cac;
				this.perimetreAntennesCC = cc;
			}
		);
	}
}